export var NegozioOpenStore = {
    infoNegozio: null,
    id_negozio: null,
    shouldOpenAppId: null,
    shouldOpenProduct: null
}
